<ui-input-wrapper [label]="base.label" [labelTemplate]="base.labelTemplate" [control]="control" [help]="base.help">
  <p-multiselect
    [options]="select.options()"
    [formControl]="$any(fc)"
    appendTo="body"
    [showClear]="true"
    [filter]="select.searchable()"
    [placeholder]="base.placeholder ? base.placeholder : 'Vyberte'"
    [overlayOptions]="{
      baseZIndex: 10004,
    }"
    [readonly]="base.readonly()"
    emptyFilterMessage="Nebyla nalezena shoda"
    (onClear)="clear()"
    (onChange)="handleChange.emit($event)"
    (onShow)="dropdown.dropdownStateChange.emit(dropdownState.Opened)"
    (onHide)="dropdown.dropdownStateChange.emit(dropdownState.Closed)"
    [optionLabel]="dropdown.bindLabel()"
    [optionValue]="dropdown.bindValue()">
  </p-multiselect>
  @if (submitted && control.errors) {
    <ui-form-error [errors]="control.errors"> </ui-form-error>
  }
</ui-input-wrapper>
